import { Route } from '@angular/router';
import { AuthGuard } from './shared/services/auth/auth-guard';

const protectedRoutes = { canActivate: [AuthGuard] };

export const appRoutes: Route[] = [
    {
        path:'Dashboard',
        loadComponent: () => import('./views/dashboard/dashboard').then((m) => m.Dashboard),
        ...protectedRoutes,
        title: 'Dashboard',
    },
    {
        path: 'login',
        redirectTo:'',
       pathMatch:'full'
    },
    {
        path :'signIn/logInCheck/:details',
        loadComponent: () => import('./views/login/login').then((m) => m.Login),
        title: 'Login',
    },
    {
        path: 'Jobs',
        loadComponent: () => import('./views/jobs/jobs').then((m) => m.Jobs),
        ...protectedRoutes,
        title: 'Jobs',
    },
    {
        path: 'ViewJob',
        loadComponent: () => import('./views/job-details/job-details').then((m) => m.JobDetails),
        ...protectedRoutes,
        title: 'Job Details',
    },
    // {
    //     path: 'job-details',
    //     loadComponent: () => import('./views/job-details/job-details').then((m) => m.JobDetails),
    //     ...protectedRoutes,
    //     title: 'Job Details',
    // },
    // {
    //     path: 'applyJob/:jobId',
    //     loadComponent: () => import('./views/share-job/share-job').then((m) => m.ShareJob),
    //     title: 'Share Job',
    // },
    {
        path: 'applyJob/:jobId',
        loadComponent: () => import('./views/apply-job/apply-job').then((m) => m.ApplyJob),
        title: 'Apply Job',
    },
    {
        path: 'Tracker',
        loadComponent: () => import('./views/tracker/tracker').then((m) => m.Tracker),
        ...protectedRoutes,
        title: 'Tracker',
    },
    {
        path: 'Joined',
        loadComponent: () => import('./views/joined/joined').then((m) => m.Joined),
        ...protectedRoutes,
        title: 'Joined',
    },
    // {
    //     path: 'quality-score',
    //     loadComponent: () =>
    //         import('./views/quality-score/quality-score').then((m) => m.QualityScore),
    //     ...protectedRoutes,
    //     title: 'Quality Score',
    // },
    {
        path: 'rewards',
        loadComponent: () => import('./views/rewards/rewards').then((m) => m.Rewards),
        ...protectedRoutes,
        title: 'Rewards',
    },
    // {
    //     path: 'leaderboard',
    //     loadComponent: () => import('./views/leaderboard/leaderboard').then((m) => m.Leaderboard),
    //     ...protectedRoutes,
    //     title: 'Leaderboard',
    // },
    {
        path: 'badges',
        loadComponent: () => import('./views/badges/badges').then((m) => m.Badges),
        ...protectedRoutes,
        title: 'Badges',
    },
    {
        path: '',
        loadComponent: () => import('./views/login/login').then((m) => m.Login),
        title: 'Login',
    },
    {
        path:'Signin',
        redirectTo:'',
        pathMatch:'full'
    },

    {
		path :'oneStepAuth/:loginData',
		loadComponent: () =>
            import('./views/one-step-login/one-step-login').then((m) => m.OneStepLogin),
        title: 'One Step Login',
    },
    {
        path: 'ssoAuth/:loginData',
        loadComponent: () => import('./shared/components/azure-login/azure-login').then((m) => m.AzureLogin),
        title: 'SSO Auth',
    },
    {
        path: 'sso_signin_Auth/:loginData',
        loadComponent: () => import('./shared/components/azure-login/azure-login').then((m) => m.AzureLogin),
        title: 'SSO Auth',
    },
    {
        path: 'Companies',
        loadComponent: () =>
            import('./shared/components/multiple-company/multiple-company').then((m) => m.MultipleCompany),
        title: 'Multiple Companies Login',
    },
    {
        path: 'forgot_password',
        loadComponent: () =>
            import('./shared/components/forgot-password/forgot-password').then((m) => m.ForgotPassword),
        title: 'Forgot Password',
    },

    {
		path :'login/:company_id/:registration_id/:employee_type',
        loadComponent: () => import('./shared/components/change-password/change-password').then((m) => m.ChangePassword),
        title: 'Reset Password',
	},
    {
        path:'change-password',
        loadComponent: () => import('./shared/components/change-password/change-password').then((m) => m.ChangePassword),
        ...protectedRoutes,
        title: 'Change Password',
    },
    // {
    //     path: 'sign_up',
    //     loadComponent: () => import('./shared/components/signup/signup').then((m) => m.Signup),
    //     title: 'Sign Up',
    // },
    {
        path: 'azure_login',
        loadComponent: () => import('./shared/components/azure-login/azure-login').then((m) => m.AzureLogin),
        title: 'Azure Login',
    },
    {
		path :'**',
		redirectTo: ''
	},
];
